import React from "react";
import ReactLoading from "react-loading";

import "./loading.css";

const LoadingSM = () => {
  return (
    <ReactLoading
      className="dashboard-loading-sm"
      type={"spinningBubbles"}
      color={"#4c3c73"}
    />
  );
};

export default LoadingSM;
